module.exports = __webpack_public_path__ + "static/media/desktop-components-buttons-icon-buttons-64-more.855d3f94.svg";